import * as Comlink from 'comlink'

// Use absolute path from public folder root (same as other workers)
const WORKER_PATH = '/custom-shape.worker.js'
let customShapeWorkerProxy = null

export async function getCustomShapeWorker() {
    if (customShapeWorkerProxy) {
        return customShapeWorkerProxy
    }

    if (typeof Worker === 'undefined') {
        throw new Error('Worker not available')
    }

    let worker
    try {
        worker = new Worker(WORKER_PATH, { type: 'module' })

        // Add error handler to catch worker loading errors
        worker.onerror = (error) => {
            console.error('Worker error:', error)
            // If worker fails to load (e.g., 404), it might return HTML error page
            // which causes "Unexpected token '<'" error
            if (error.message && error.message.includes("Unexpected token")) {
                console.error(
                    'Worker file not found or invalid. Please run: yarn build:worker:custom-shape'
                )
            }
        }

        customShapeWorkerProxy = Comlink.wrap(worker)
    } catch (error) {
        console.error('Failed to create custom shape worker:', error)
        // Check if error is about loading worker file
        if (error.message && (error.message.includes('Failed to fetch') || error.message.includes('404'))) {
            throw new Error(
                'Custom shape worker file not found. Please build workers first: yarn build:worker:custom-shape'
            )
        }
        throw new Error(`Custom shape worker not available: ${error.message}`)
    }

    try {
        // Add timeout for ping to detect if worker is not responding
        const pingPromise = customShapeWorkerProxy.ping()
        const timeoutPromise = new Promise((_, reject) => {
            setTimeout(() => reject(new Error('Worker ping timeout')), 5000)
        })

        const ping = await Promise.race([pingPromise, timeoutPromise])
        if (ping !== 'pong') {
            throw new Error('Custom shape worker not responding')
        }
    } catch (error) {
        console.error('Failed to ping custom shape worker:', error)
        customShapeWorkerProxy = null // Reset proxy on error

        // Provide helpful error message
        if (error.message && error.message.includes('timeout')) {
            throw new Error(
                'Custom shape worker not responding. The worker file may not be built. Please run: yarn build:worker:custom-shape'
            )
        }
        throw new Error(`Custom shape worker not responding: ${error.message}`)
    }

    return customShapeWorkerProxy
}
